import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";
import useLenis from "@/hooks/useLenis";
import "@/App.css";

const Home = lazy(() => import("@/pages/Home"));
const Donna = lazy(() => import("@/pages/Donna"));
const Uomo = lazy(() => import("@/pages/Uomo"));
const Neonato = lazy(() => import("@/pages/Neonato"));
const Abbigliamento = lazy(() => import("@/pages/Abbigliamento"));
const Lavanderia = lazy(() => import("@/pages/Lavanderia"));
const Stireria = lazy(() => import("@/pages/Stireria"));
const Sartoria = lazy(() => import("@/pages/Sartoria"));
const Prodotti = lazy(() => import("@/pages/Prodotti"));
const Occasioni = lazy(() => import("@/pages/Occasioni"));
const Foto = lazy(() => import("@/pages/Foto"));
const Feste = lazy(() => import("@/pages/Feste"));
const Contatti = lazy(() => import("@/pages/Contatti"));
const Cookie = lazy(() => import("@/pages/Cookie"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const NotFound = lazy(() => import("@/pages/NotFound"));

function Fallback() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="w-10 h-10 rounded-full border-2 border-[color:var(--fucsia)] border-t-transparent animate-spin" />
    </div>
  );
}

export default function App() {
  useLenis();
  return (
    <div className="App bg-white text-[color:var(--ink)]">
      <ScrollToTop />
      <Navbar />
      <main>
        <Suspense fallback={<Fallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/abbigliamento" element={<Abbigliamento />} />
            <Route path="/abbigliamento-donna-livorno" element={<Donna />} />
            <Route path="/abbigliamento-uomo-livorno" element={<Uomo />} />
            <Route path="/abbigliamento-neonato-livorno" element={<Neonato />} />
            <Route path="/lavanderia-livorno" element={<Lavanderia />} />
            <Route path="/stireria-livorno" element={<Stireria />} />
            <Route path="/sartoria-livorno" element={<Sartoria />} />
            <Route path="/prodotti-bucato-livorno" element={<Prodotti />} />
            <Route path="/occasioni" element={<Occasioni />} />
            <Route path="/foto" element={<Foto />} />
            <Route path="/feste" element={<Feste />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/cookie" element={<Cookie />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
